import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './UserNavItem.scss';
import { UserNavItemPopover } from 'components'

class UserNavItem extends Component {
	state = {
		initials: "",
        account_name: "",
        open: false
	}

	componentDidMount() {
		this.initialsHandler();
	}

	initialsHandler = () => {
		//get the first name from auth
		if (this.props.auth.first_name && this.props.auth.last_name){
			this.setState(prevState => ({
                ...prevState,
				initials: this.props.auth.first_name.substr(0,1).toUpperCase() + this.props.auth.last_name.substr(0,1).toUpperCase()
			}));
		}
        //get account name from auth
        if(this.props.auth.account_name) {
            this.setState(prevState => ({
                ...prevState,
                account_name: this.props.auth.account_name
			}));
        }
	}

    toggleOpen = () => {
        this.setState(prevState => ({
            ...prevState,
            open: !prevState.open
        }));
    }
    
  	render() {
        if(!this.state.initials.length) {
            return null;
        }
        return (
            <div className={styles.userNavItemOuter}>
                {this.state.account_name && (
                    <div className={styles.userNavItemAccountName} data-cy-id="floating-navigation-user-account-name">
                        <div className={styles.inner}>{this.state.account_name}</div>
                    </div>
                )}
                <div className={styles.userNavItem}>
                    <a onClick={this.toggleOpen} data-cy-id="floating-navigation-user-initials"><span>{this.state.initials}</span></a>
                    <UserNavItemPopover open={this.state.open} onClickOutside={this.toggleOpen}/>
                </div>
            </div>
        );
	}
}

const mapStateToProps = state => {
    return {
        auth: state.auth,
    };
};

const mapDispatchToProps = dispatch => {
    return {}
};
export default connect(mapStateToProps,mapDispatchToProps)(UserNavItem);


// WEBPACK FOOTER //
// ./src/components/molecules/UserNavItem/index.js